const SENTIMENT_ENTRIES: readonly [string, string][] = [
  ["positive", "Positive"],
  ["negative", "Negative"],
  ["neutral", "Neutral"],
  ["unknown", "—"],
];

/** Labels for reply sentiment analysis. */
export const SENTIMENT_LABELS: Record<string, string> = Object.fromEntries(SENTIMENT_ENTRIES);

export function sentimentLabel(sentiment: string | null | undefined): string {
  if (sentiment == null || sentiment === "") return "—";
  return SENTIMENT_LABELS[sentiment] ?? sentiment;
}

/** Tailwind-compatible classes for sentiment: border, badge, summaryBg. */
export function sentimentStyles(sentiment: string): {
  border: string;
  badge: string;
  summaryBg: string;
} {
  switch (sentiment) {
    case "positive":
      return {
        border: "border-l-emerald-500",
        badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
        summaryBg: "bg-emerald-50/80 border-emerald-200",
      };
    case "negative":
      return {
        border: "border-l-rose-500",
        badge: "bg-rose-100 text-rose-800 border border-rose-200",
        summaryBg: "bg-rose-50/80 border-rose-200",
      };
    case "neutral":
      return {
        border: "border-l-sky-500",
        badge: "bg-sky-100 text-sky-800 border border-sky-200",
        summaryBg: "bg-sky-50/80 border-sky-200",
      };
    default:
      return {
        border: "border-l-gray-400",
        badge: "bg-gray-100 text-gray-700 border border-gray-200",
        summaryBg: "bg-gray-50 border-gray-200",
      };
  }
}

const SENTIMENT_BADGE_BASE = "inline-flex rounded-full border px-2 py-0.5 text-xs font-medium";

/** Full class string for table/list sentiment badges. */
export function sentimentBadgeClassName(sentiment: string): string {
  return `${SENTIMENT_BADGE_BASE} ${sentimentStyles(sentiment).badge}`;
}
